var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08312 15.2709L16.1964 3.16731C17.7522 1.6109 20.2766 1.6109 21.8332 3.16731C23.3889 4.72294 23.3889 7.24618 21.8332 8.80181L9.71991 20.907C8.34238 22.2837 2.92918 23.5095 2.20445 22.7846C1.50708 22.0877 2.70793 16.6461 4.08312 15.2709ZM20.9028 7.87776L19.9561 8.82436L16.1698 5.04418L17.1205 4.09524C18.1649 3.05064 19.8583 3.05064 20.9028 4.09524C21.9481 5.13985 21.9481 6.83393 20.9028 7.87776ZM9.21253 19.5613C9.15545 19.6166 9.08666 19.6741 9.01238 19.7309C8.97017 19.0713 8.69184 18.4234 8.17195 17.9186L8.08908 17.8385L17.6083 8.33434L19.0281 9.75152L9.21253 19.5613ZM4.66244 16.9735C3.82278 18.6661 3.06834 21.3075 3.37559 21.6155C3.65782 21.8987 6.16819 21.2018 7.86704 20.3967C7.76619 19.6757 7.42454 18.9702 6.84366 18.4047L6.29171 17.8711C5.82263 17.413 5.25582 17.126 4.66244 16.9735ZM5.42938 15.7788L15.2418 5.97133L16.6795 7.40718L7.14779 16.9238L6.79363 16.5792C6.39022 16.1887 5.90003 15.9429 5.38482 15.8309C5.39011 15.8248 5.3954 15.8182 5.4007 15.8117L5.40074 15.8116C5.41029 15.7997 5.41984 15.7878 5.42938 15.7788Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a1f5a7e8435486f72989cedaed6afb70.svg";
export { ForwardRef as ReactComponent };